import { observer } from 'mobx-react-lite'
import { TagsListHeader } from 'pages/settings/pages/tags/ui/TagsList/TagsListHeader'
import { TagsListSearch } from 'pages/settings/pages/tags/ui/TagsList/TagsListSearch'
import { TagsListTable } from 'pages/settings/pages/tags/ui/TagsListTable/TagsListTable'
import styles from './styles.module.scss'

export const TagsList = observer(() => {
  return (
    <section className={styles.page}>
      <TagsListHeader />

      <div className={styles.wrap}>
        <TagsListSearch />
        <TagsListTable />
      </div>
    </section>
  )
})
